<div class="pdf-container">
  <div class="pdf-description d-flex gap-3">
    <div class="pdf-success">
      @if (textoAdicional()) {
        <p class="info-pdf info-pdf-adicional">{{ textoAdicional() }}</p>
      }
      @if (textoInformativo()) {
        @if (tipoInformativo() === 'sucesso') {
          <img src="assets/images/icons/fi_check-circle.svg" alt="" />
        }
        <p class="info-pdf" [class.info-pdf-aviso]="tipoInformativo() === 'aviso'">{{ textoInformativo() }}</p>
      }
    </div>
    <div class="pdf-toolbar">
      <div class="pdf-controls">
        <button class="pdf-btn" (click)="zoomIn()" [disabled]="zoom() >= zoomMaximo" title="Aumentar zoom">
          <img src="assets/images/icons/fi_zoom-in.svg" alt="zoom-in" />
        </button>
        <button class="pdf-btn" (click)="zoomOut()" [disabled]="zoom() <= zoomMinimo" title="Diminuir zoom">
          <img src="assets/images/icons/fi_zoom-out.svg" alt="zoom-out" />
        </button>
        <button class="pdf-btn" (click)="toggleFullscreen()"
          [title]="isFullscreen() ? 'Fechar tela cheia' : 'Tela cheia'">
          <img src="assets/images/icons/fi_maximize-2.svg" alt="fullscreen" />
        </button>
      </div>
    </div>
  </div>
  <div class="pdf-box">
    <div class="pdf-file-wrapper">
      <div class="pdf-file-container" [class.fullscreen]="isFullscreen()">
        @if (isFullscreen()) {
          <button class="btn close-fullscreen-btn" (click)="toggleFullscreen()">
            Fechar <img src="assets/images/icons/la_times.svg" alt="">
          </button>
        }

        @if (src()) {
          <pdf-viewer
            [src]="src()"
            [render-text]="true"
            [original-size]="false"
            [show-all]="true"
            [autoresize]="true"
            [zoom-scale]="'page-width'"
            [zoom]="zoom()"
            class="pdf-file">
          </pdf-viewer>
        }
      </div>
    </div>
  </div>
</div>
